import { useUser } from './UserProvider';
/**
 * @component Requires
 * @since 1.0.0
 */
export function Requires(props) {
    const { permission, label, operator } = props;
    const user = useUser();
    return user.can(permission, operator) ? props.children || null : null;
}
